// スムーススクロール ページ内遷移
// a要素にアンカー id="#〇〇" と class="js__link-scroll" を追加
var recruit = {
  init: function() {
    $(document).ready(function() {
      //通常のクリック時
      $(".js__link-scroll").on("click", function(e) {
        //リンク無効化
        e.preventDefault();
        //ページ内リンク先を取得 #のみのときは空にする
        var href= $(this).attr("href");
        var hash = href == "#" ? '' : href;

        //アンカーと一致するidがないときは動かない
        if ( $(hash).length > 0) {
          //スクロール実行
          scrollToAnker(hash);
        } else {
          return;
        }
      });

      // 関数：スムーススクロール
      // 指定したアンカー(#ID)へアニメーションでスクロール
      function scrollToAnker(hash) {
        var target = $(hash);
        var position = target.offset().top - $("#l-header__fixed").height();
        $("body,html")
          .stop()
          .animate({ scrollTop: position }, 500);
      }
    });
  }
};

// 中途採用のページで実行
if ($("#p-career")[0]) {
  recruit.init();
}
